import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const add_award = createAsyncThunk(
  "award/add_award",
  async (award, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/award-add", award, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const update_award = createAsyncThunk(
  "award/updateaward",
  async (award, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/award-update", award, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const award_image_update = createAsyncThunk(
  "award/award_image_update",
  async ({ oldImage, newImage, awardId }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("oldImage", oldImage);
      formData.append("newImage", newImage);
      formData.append("awardId", awardId);
      const { data } = await api.post("/award-image-update", formData, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_awards = createAsyncThunk(
  "award/get_awards",
  async ({ parPage, page, searchValue }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/awards-get?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        { withCredentials: true }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_award = createAsyncThunk(
  "award/get_award",
  async (awardId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/award-get/${awardId}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const delete_award = createAsyncThunk(
  "award/delete_award",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/award-delete/${id}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const awardReducer = createSlice({
  name: "award",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    awards: [],
    award: "",
    totalaward: 0,
  },
  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [add_award.pending]: (state) => {
      state.loader = true;
    },
    [add_award.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [add_award.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
    },

    [get_awards.pending]: (state) => {
      state.loader = true;
    },
    [get_awards.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [get_awards.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.totalaward = payload.totalaward;
      state.awards = payload.awards;
    },

    [get_award.pending]: (state) => {
      state.loader = true;
    },
    [get_award.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [get_award.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.award = payload.award;
    },

    [update_award.pending]: (state) => {
      state.loader = true;
    },
    [update_award.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [update_award.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.award = payload.award;
      state.successMessage = payload.message;
    },

    [award_image_update.pending]: (state) => {
      state.loader = true;
    },
    [award_image_update.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [award_image_update.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.award = payload.award;
      state.successMessage = payload.message;
    },

    [delete_award.pending]: (state) => {
      state.loader = true;
    },
    [delete_award.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [delete_award.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      // Remove deleted award from awards list
      state.awards = state.awards.filter((p) => p._id !== payload.awardId);
    },
  },
});

export const { messageClear } = awardReducer.actions;
export default awardReducer.reducer;
